import script from "./OnboardingAiStructureOptionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiStructureOptionCard.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiStructureOptionCard.vue?vue&type=style&index=0&id=043c5a40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043c5a40"]])

export default __exports__